function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { getValidElementProps } from '../utils/htmlValidProps';
var propTypes = {
  id: PropTypes.string,
  children: PropTypes.node
};

var Option = function Option(props) {
  var id = props.id,
      children = props.children;
  var optionProps = getValidElementProps('option', props);
  return /*#__PURE__*/React.createElement("option", _extends({}, optionProps, {
    id: id
  }), children);
};

Option.propTypes = propTypes;
Option.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Option",
  "props": {
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};
export default Option;